<template>
  <div>
    <vue-good-table
        ref="superBomComponentTable"
        class="mx-4"
        :columns="columns"
        :rows="superBomComponents"
        :select-options="{
          enabled: true,
          selectAllByGroup: true,
        }"
        :line-numbers="false"
        :group-options="{
          enabled: true,
          headerPosition: 'top',
          collapsable: true
        }"
        :sort-options="{
          enabled: true,
          multipleColumns: true,
          initialSortBy: [
            {field: 'type_component', type: 'asc'},
          ],
        }"
    >
      <div slot="table-actions">
        <md-button class="md-icon-button md-dense md-primary" v-on:click="expandAllGroup">
          <md-icon>unfold_more</md-icon>
        </md-button>
        <md-button class="md-icon-button md-dense md-primary" v-on:click="collapseAllGroup">
          <md-icon>unfold_less</md-icon>
        </md-button>
      </div>
      <div slot="emptystate">There are no entries</div>
      >

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'component_info'">
          {{ props.row.component_info }}
        </span>
        <span v-else-if="props.column.field == 'action'">
          <md-button class="md-icon-button md-dense md-accent" v-on:click="removeFromGroup(props.row)">
            <md-icon>remove_circle</md-icon>
          </md-button>
        </span>
        <span v-else-if="props.column.field == 'search_value'">
          <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
        </span>
<!--        <span v-else-if="props.column.field == 'id'">-->

<!--        </span>-->
      </template>

      <template slot="table-header-row" slot-scope="props">
          <span v-if="props.column.field == 'component_info'">
            {{ props.row.component_info }}
          </span>
        <span v-else-if="props.column.field == 'action'">
            <md-button class="md-icon-button md-dense md-primary" v-on:click="moveSelectedToBom(props.row)">
              <md-icon>move_to_inbox</md-icon>
            </md-button>
        </span>
        <span v-else-if="props.column.field == 'search_value'">
          <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
        </span>
      </template>

      <div slot="selected-row-actions">
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import SearchValue from "@/components/SuperBom/SearchValue";

export default {
  name: 'SuperBomComponentList',
  components: {
    VueGoodTable,
    SearchValue,
  },
  computed: {
    ...mapGetters(['allSuperBomComponents', 'superBomComponents']),
    blankString() {
      return ''
    }
  },
  methods: {
    ...mapActions(['fetchSuperBomComponents']),
    moveSelectedToBom(row) {
      const props = {
        'destinationRow': row,
        'selectedRows': this.$refs['superBomComponentTable'].selectedRows
      }
      this.$store.dispatch('actionMoveSelectedToBom', props).then(() => {
        this.$refs['superBomComponentTable'].unselectAllInternal()
      })
    },
    removeFromGroup(props) {
      this.$store.dispatch('actionRemoveFromGroup', props).then(() => {
        this.$refs['superBomComponentTable'].unselectAllInternal()
      })
    },
    refreshPage() {
      this.fetchSuperBomComponents(this.$route.params.superBomId);
    },
    expandAllGroup() {
      this.$refs.superBomComponentTable.expandAll()
    },
    collapseAllGroup() {
      this.$refs.superBomComponentTable.collapseAll()
    },
  },
  async mounted() {
    this.fetchSuperBomComponents(this.$route.params.superBomId);
  },
  data() {
    return {
      selected_count: 0,
      columns: [
        // {
        //   label: 'ID',
        //   field: 'id',
        //   type: 'number',
        // },
        {
          label: 'Type component',
          field: 'type_component',
          type: 'text',
          filterOptions: {
            styleClass: 'class1', // class to be added to the parent th element
            enabled: true, // enable filter for this column
            // placeholder: 'Filter', // placeholder for filter input
            // filterValue: 'Jane', // initial populated value for this filter
            filterDropdownItems: ['capacitor', 'resistor', 'mpn_component'], // dropdown (with selected values) instead of text input
            // filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
        {
          label: 'search_value',
          field: 'search_value',
          type: 'text',
        },
        {
          label: 'version',
          field: 'version',
          headerField: 'blankString',
          type: 'text',
          tdClass: 'resizeFont'
        },
        {
          label: 'count',
          field: 'count',
          headerField: 'childrenCount',
          type: 'number',
        },
        {
          label: 'quantity',
          field: 'quantity',
          headerField: 'childrenSum',
          type: 'number',
        },
        {
          label: 'action',
          field: 'action',
          type: 'text',
          tdClass: 'resizeFont'
        },
      ],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.superBom {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 1rem;
}

small {
  display: block;
}
</style>